// extracted by mini-css-extract-plugin
export default {"button":"rA1344","solid":"as3852","wireframe":"ii7cHd","text":"JiPlI6","textWithIcon":"pgdS1O","logout":"dBJiJm","login":"cdOR60"};